import { isFunction } from 'lodash';
import { DateTime, Settings } from 'luxon';
// To fix problem with jest. For reference:
// https://stackoverflow.com/questions/39830580/jest-test-fails-typeerror-window-matchmedia-is-not-a-function

export const addMatchMediaToWindow = (): void => {
    Object.defineProperty(window, 'matchMedia', {
        writable: true,
        value: jest.fn().mockImplementation(query => ({
            matches: false,
            media: query,
            onchange: null,
            addListener: jest.fn(), // Deprecated
            removeListener: jest.fn(), // Deprecated
            addEventListener: jest.fn(),
            removeEventListener: jest.fn(),
            dispatchEvent: jest.fn(),
        })),
    });
};

const originalNow = Settings.now;

export const mockLuxonNow = (isoString: string): void => {
    const newNow = DateTime.fromISO(isoString);
    Settings.now = () => newNow.toMillis();
};

export const restoreLuxonNow = (): void => {
    Settings.now = originalNow;
};

type MockOrObject = jest.Mock | unknown;

const isMock = (mock: MockOrObject): mock is jest.Mock => {
    // eslint-disable-next-line
    return isFunction(mock) && Boolean((mock as any)?._isMockFunction);
};

export const clearMocks = (...mocks: MockOrObject[]): void => {
    mocks.map(mock => {
        if (isMock(mock)) mock.mockClear();
        else if (Array.isArray(mock)) mock.map(m => clearMocks(m));
        else mock && clearMocks(Object.values(mock));
    });
};
